<!-- https://primefaces.org/primeng/showcase/#/setup -->

<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!-- 		 	 -->
<!-- LOCK TO TOP -->
<!-- 			 -->
<div class="lock-to-top" style="background-color: #ffffff">
	<div class="selector-body">
		<!-- 				 -->
		<!-- School Selector -->
		<!-- 				 -->
		<div class="selector-item">
			<div>
				<label>School</label>
			</div>

			<div style="margin-left: 10px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<!-- <select class="form-control" name="SchoolSelector" style="font-size:smaller;"
					[(ngModel)]="SelectedSchool"
					(ngModelChange)="onSchoolChange($event)">
					<option *ngFor="let r of lstSchool" [ngValue]="r">{{r.SchoolNumber}} - {{r.SchoolName}}</option>
				</select> -->

				<caass-schoolselector [ShowAll]="SchoolSelectShowAll" [ShowAllID]="SchoolSelectShowAllID" [ShowAllText]="SchoolSelectShowAllText">
				</caass-schoolselector>
			</div>
		</div>
	</div>

	<!-- 		 -->
	<!-- Buttons -->
	<!-- 		 -->
	<div class="button-body">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onEdit()">Edit</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onToggleActive()">Toggle Active</button>
		<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />
	</div>

	<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo == true ? 'block' : 'none'">
		<label>&#9900; Total facility locations: {{ lstFacilityLocation.length }}</label
		><br />
		<label>&#9900; Use ctl to add a column to the sort selection</label><br />
	</div>
</div>

<!-- 				  	    -->
<!-- Display Location Items -->
<!-- 					    -->
<div class="table-main-body">
	<!-- Note: resizableColumns breaks the multiline ability -->

	<p-table
		#mydt
		[value]="lstFacilityLocation"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedFacilityLocation"
		dataKey="FacilityLocationID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50]"
	>
		<ng-template pTemplate="header">
			<!-- 				-->
			<!-- Filter Section -->
			<!-- 				-->
			<tr>
				<th class="fixwidth-06">
					<div class="table-filter-row-group">
						<!-- 				   -->
						<!-- Display When Busy -->
						<!-- 				   -->
						<div [style.display]="isBusy == true ? 'block' : 'none'" style="width: 20px">
							<img class="busy-img" src="assets/images/loading.gif" />
						</div>
						<div [style.display]="isBusy == false ? 'block' : 'none'" style="width: 20px"></div>
					</div>
				</th>

				<th class="fixwidth-09">
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActive
								[ngModel]="value"
								[options]="lstActives"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<p-columnFilter type="text" field="FacilityLocationName" matchMode="startsWith" [showMenu]="true"></p-columnFilter>
				</th>

				<th>
					<p-columnFilter field="FacilityName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterFacilityName
								[ngModel]="value"
								[options]="lstFacilitys"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<p-columnFilter field="FacilityLocationCD" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterFacilityLocationCD
								[ngModel]="value"
								[options]="lstFacilityLocationCDs"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!-- 			  -->
			<!-- Sort Section -->
			<!-- 			  -->
			<tr style="height: 4rem">
				<th class="fixwidth-06"></th>
				<th pSortableColumn="Active" class="fixwidth-09">Active<p-sortIcon field="Active"></p-sortIcon></th>
				<th pSortableColumn="FacilityLocationName">Facility Location<p-sortIcon field="FacilityLocationName"></p-sortIcon></th>
				<th pSortableColumn="FacilityName">Facility Name<p-sortIcon field="FacilityName"></p-sortIcon></th>
				<th pSortableColumn="FacilityLocationCD">Code<p-sortIcon field="FacilityLocationCD"></p-sortIcon></th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rLocationItem>
			<tr [pSelectableRow]="rLocationItem">
				<td class="fixwidth-06">
					<!-- Fee space filler -->
				</td>

				<td>
					<div class="fixwidth-09">
						<i
							class="pi"
							[ngClass]="{
								'pi-check-circle table-active': rLocationItem.Active,
								'pi-ban table-inactive': !rLocationItem.Active
							}"
						></i>
					</div>
				</td>

				<td>
					<div class="table-data-location">
						{{ rLocationItem.FacilityLocationName }}
					</div>
				</td>

				<td>
					<div class="table-data-location">
						{{ rLocationItem.FacilityName }}
					</div>
				</td>

				<td>
					<div class="table-data-location">
						{{ rLocationItem.FacilityLocationCD }}
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!-- 						  -->
<!-- Display When No Location -->
<!-- 					      -->
<div style="padding: 20px" [style.display]="lstFacilityLocation.length < 1 && isBusy == false ? 'block' : 'none'">
	<label>No Facility Locations configured...</label>
</div>

<!-- 					  -->
<!-- Delete Error Message -->
<!-- 					  -->
<div style="padding: 20px; color: #e61010" [style.display]="ErrorMessage != '' ? 'block' : 'none'">
	<label>{{ ErrorMessage }}</label>
</div>
